export const headerConfig = {
  headerTitle: 'Marriage Exemption Certificates',
  headerDescription: 'List of Marriage Exemption Certificates',
  refreshButton: {
    id: 'refresh',
    label: 'Refresh',
    icon: 'RefreshIcon',
  },
};
